import { AppBar, Backdrop, CircularProgress, Grid, makeStyles, Tab, Tabs, Typography } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import Activities from "./activities/page";
import { choicesState, loadingState, predictionState, progressState } from "./atoms";
import TIPIs from "./tipi/page";
import { predict } from "./utils";
import Words from "./words/page";
import * as tf from '@tensorflow/tfjs'

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

const App = () => {
  const classes = useStyles()
  const [selectedTab, setSelectedTab] = useState(0)
  const setPrediction = useSetRecoilState(predictionState)
  const [loading, setLoading] = useRecoilState(loadingState)
  const [progress, setProgress] = useRecoilState(progressState)
  const choices = useRecoilValue(choicesState)
  useEffect(() => {
    const downloadModels = async () => {
      setProgress(0)
      const models = [
        [0, 0, 0], [10, 0, 0], [20, 0, 0], [30, 0, 0], [40, 0, 0], [50, 0, 0], [60, 0, 0], [70, 0, 0], [80, 0, 0], [90, 0, 0], [100, 0, 0],
        [100, 10, 0], [100, 20, 0], [100, 30, 0], [100, 40, 0], [100, 50, 0], [100, 60, 0], [100, 70, 0], [100, 80, 0], [100, 90, 0], [100, 100, 0],
        [100, 100, 10], [100, 100, 20], [100, 100, 30], [100, 100, 40], [100, 100, 50], [100, 100, 60], [100, 100, 70], [100, 100, 80], [100, 100, 90], [100, 100, 100]
      ]
      for (let i = 0; i < models.length; i++) {
        const [activities, tenPersonalItemInventory, wordDefinitions] = models[i]
        try {
          await tf.loadLayersModel(`indexeddb://${activities}_${tenPersonalItemInventory}_${wordDefinitions}_percent_model`)
        } catch (error) {
          const model = await tf.loadLayersModel(`https://personality.rezanmz.com/models/${activities}_${tenPersonalItemInventory}_${wordDefinitions}_percent/model.json`)
          await model.save(`indexeddb://${activities}_${tenPersonalItemInventory}_${wordDefinitions}_percent_model`)
        }
        setProgress(((i + 1) / models.length) * 100)
      }
      setProgress(null)
    }

    const getPredictions = async () => {
      setLoading(true)
      const [activitiesPrediction, tenPersonalItemInventoryPrediction, wordDefinitionsPrediction] = await predict(choices.activities, choices.tenPersonalItemInventory, choices.wordDefinitions)
      setPrediction({
        activities: activitiesPrediction,
        tenPersonalItemInventory: tenPersonalItemInventoryPrediction,
        wordDefinitions: wordDefinitionsPrediction
      })
      setLoading(false)
    }

    downloadModels()
    getPredictions()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <>
      <AppBar position='static'>
        <Tabs centered value={selectedTab} onChange={(event, newValue) => setSelectedTab(newValue)}>
          <Tab label='Activities' id={0} />
          <Tab wrapped label='Ten Item Personality Inventory' id={1} />
          <Tab label='Word Definitions' id={2} />
        </Tabs>
      </AppBar>
      <Grid container style={{ justifyContent: 'center', marginTop: '20px' }}>
        {selectedTab === 0 && (<Activities />)}
        {selectedTab === 1 && (<TIPIs />)}
        {selectedTab === 2 && (<Words />)}
      </Grid>
      <Backdrop className={classes.backdrop} open={loading | progress}>
        <CircularProgress color="inherit" />
        {progress !== null && (
          <Typography>
            Downloading models: {Math.round(progress)}%
          </Typography>
        )}
      </Backdrop>
    </>
  )
}

export default App;
